(() => {
  "use strict";

  if (window.__estailoATCLoaded) return;

  const CONFIG = {
    // FIX: Public web app URL (Deploy > Manage deployments).
    // Execute as: Me | Who has access: Anyone
    // Format: https://script.google.com/macros/s/XXXX/exec
    // NOTE: URL mein "/a/macros/<domain>/" NAHI hona chahiye.
    endpoint: "https://script.google.com/macros/s/AKfycbwnb496IPrecvvatLysfTEvOPIY-S0Y6E4sxKes4nnLa5w3DOhtoYizgjfeff3zjBIF/exec",
    timeoutMs: 8000,
    version: "1.0.2",

    // Dawn product forms plus optional app-specific add-to-cart buttons.
    selectors: [
      'product-form form[data-type="add-to-cart-form"] button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form__submit[type="submit"]',
      '.quick-add__submit[type="submit"]',
      'button[data-add-to-cart]',
      'button[data-atc]'
    ].join(", ")
  };

  const active = new Map();

  function id() {
    return window.crypto?.randomUUID?.() ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  const sessionId = (() => {
    try {
      const key = "estailo_atc_session";
      let value = sessionStorage.getItem(key);
      if (!value) {
        value = id();
        sessionStorage.setItem(key, value);
      }
      return value;
    } catch (_) {
      return id();
    }
  })();

  // Only real add-to-cart calls (not cart/update or cart/change).
  function isCartAdd(url) {
    if (!url) return false;

    try {
      const parsed = new URL(url, location.href);
      if (parsed.origin !== location.origin) return false;

      const path = parsed.pathname.replace(/\/$/, "");
      const root = window.Shopify?.routes?.root || "/";
      const prefix = root.replace(/\/$/, "");

      return path === prefix + "/cart/add" ||
             path === prefix + "/cart/add.js";
    } catch (error) {
      console.error("ATC URL detection error:", error);
      return false;
    }
  }

  function buttonLabel(el) {
    return (
      el.innerText ||
      el.value ||
      el.getAttribute("aria-label") ||
      ""
    ).trim();
  }

  function findButton(target) {
    if (!(target instanceof Element)) return null;

    const button = target.closest(CONFIG.selectors);
    if (button) return button;

    // Fallback: identify likely ATC button by visible label.
    const candidate = target.closest(
      'button, input[type="submit"], [role="button"]'
    );
    if (!candidate) return null;

    return /add to (cart|bag)/i.test(buttonLabel(candidate))
      ? candidate : null;
  }

  function buttonType(button) {
    if (button.closest('.quick-add, [data-quick-add], quick-add-modal'))
      return "quick_add";

    if (location.pathname.includes("/collections/")) return "collection";
    if (location.pathname.includes("/products/")) return "product_page";

    return "other";
  }

  function getVariant(button) {
    const form = button.closest("form");
    if (!form) return "";

    const field = form.querySelector('[name="id"], [name="items[0][id]"]');
    return field?.value || "";
  }

  function trafficSource() {
    const params = new URLSearchParams(location.search);
    const utm = params.get("utm_source");
    if (utm) return utm;

    if (!document.referrer) return "direct_or_unknown";

    try {
      const host = new URL(document.referrer).hostname;
      return host === location.hostname ? "internal" : host;
    } catch (_) {
      return "unknown";
    }
  }

  function device() {
    return matchMedia("(max-width: 767px)").matches ? "mobile" : "desktop";
  }

  function send(data) {
    if (!CONFIG.endpoint.startsWith("https://")) return;

    // Placeholder URL ho to mat bhejo
    if (CONFIG.endpoint.includes("PASTE_YOUR_DEPLOYMENT_ID_HERE")) {
      console.warn("ATC tracker: endpoint URL set nahi hai");
      return;
    }

    const payload = JSON.stringify({
      type: "estailo_atc",
      ...data
    });

    // text/plain avoids a JSON CORS preflight.
    const blob = new Blob([payload], { type: "text/plain" });

    try {
      if (navigator.sendBeacon && navigator.sendBeacon(CONFIG.endpoint, blob)) return;
    } catch (_) {}

    fetch(CONFIG.endpoint, {
      method: "POST",
      mode: "no-cors",
      keepalive: true,
      body: payload,
      headers: { "Content-Type": "text/plain" }
    }).catch(() => {});
  }

  function finish(attempt, status, extra = {}) {
    if (!attempt || attempt.finished) return;

    attempt.finished = true;
    clearTimeout(attempt.timer);
    active.delete(attempt.eventId);

    const responseMs = Math.round(performance.now() - attempt.start);

    send({
      timestamp: attempt.timestamp,
      eventId: attempt.eventId,
      sessionId,
      pageUrl: attempt.pageUrl,
      product: attempt.product,
      variantId: attempt.variantId,
      buttonType: attempt.buttonType,
      status,
      responseMs,
      httpStatus: extra.httpStatus || "",
      error: extra.error || "",
      device: attempt.device,
      source: attempt.source,
      browser: navigator.userAgent.slice(0, 250),
      version: CONFIG.version
    });

    window.dispatchEvent(new CustomEvent("estailo:atc-result", {
      detail: { id: attempt.eventId, status, responseMs }
    }));
  }

  function createAttempt(button) {
    const attempt = {
      eventId: id(),
      timestamp: new Date().toISOString(),
      start: performance.now(),
      pageUrl: location.href,
      product:
        button.closest("[data-product-title]")?.getAttribute("data-product-title") ||
        document.querySelector("h1")?.textContent?.trim() || "",
      variantId: getVariant(button),
      buttonType: buttonType(button),
      device: device(),
      source: trafficSource(),
      requestStarted: false,
      finished: false
    };

    attempt.timer = setTimeout(() => {
      finish(attempt, "suspected_dead", {
        error: attempt.requestStarted
          ? "No completed cart response within timeout"
          : "No matching cart request detected"
      });
    }, CONFIG.timeoutMs);

    active.set(attempt.eventId, attempt);
    return attempt;
  }

  // Correlation is time-based, not a guaranteed transaction ID.
  function matchAttempt() {
    const available = Array.from(active.values())
      .filter(a => !a.finished && !a.requestStarted)
      .sort((a, b) => a.start - b.start);

    const attempt = available[0];
    if (attempt) attempt.requestStarted = true;
    return attempt;
  }

  // Capture clicks before normal bubble-phase handlers.
  document.addEventListener("click", event => {
    const button = findButton(event.target);
    if (!button || button.disabled ||
        button.getAttribute("aria-disabled") === "true") return;

    // FIX: "Choose options / Select options" button cart request nahi bhejta,
    // isliye false "suspected_dead" se bachne ke liye skip karo.
    if (/choose|select|view|options|notify|sold out/i.test(buttonLabel(button)) &&
        !/add to (cart|bag)/i.test(buttonLabel(button))) return;

    createAttempt(button);
  }, true);

  // Some ATC forms are submitted through the Enter key.
  document.addEventListener("submit", event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!isCartAdd(form.getAttribute("action"))) return;

    // Avoid double counting a click-triggered submit.
    const recent = Array.from(active.values()).some(a =>
      !a.finished && performance.now() - a.start < 500
    );

    if (!recent) {
      const button = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      );
      if (button) createAttempt(button);
    }
  }, true);

  // Observe AJAX fetch requests without changing their result.
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const input = args[0];
    const url = typeof input === "string" ? input : input?.url;

    const method = (
      args[1]?.method ||
      (input instanceof Request ? input.method : "GET")
    ).toUpperCase();

    const tracked = method === "POST" && isCartAdd(url);
    const attempt = tracked ? matchAttempt() : null;

    let result;
    try {
      result = originalFetch.apply(this, args);
    } catch (err) {
      if (attempt) finish(attempt, "failed", { error: String(err) });
      throw err;
    }

    if (!attempt) return result;

    return Promise.resolve(result).then(response => {
      finish(attempt, response.ok ? "success" : "failed", {
        httpStatus: response.status,
        error: response.ok ? "" : `HTTP ${response.status}`
      });
      return response;
    }, error => {
      finish(attempt, "failed", { error: String(error) });
      throw error;
    });
  };

  // Observe XMLHttpRequest-based cart calls.
  const oldOpen = XMLHttpRequest.prototype.open;
  const oldSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__estailoTrack =
      String(method).toUpperCase() === "POST" && isCartAdd(url);

    return oldOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    const attempt = this.__estailoTrack ? matchAttempt() : null;

    if (attempt) {
      this.addEventListener("loadend", () => {
        const ok = this.status >= 200 && this.status < 300;
        finish(attempt, ok ? "success" : "failed", {
          httpStatus: this.status,
          error: ok ? "" : `XHR HTTP ${this.status}`
        });
      }, { once: true });
    }

    try {
      return oldSend.apply(this, args);
    } catch (err) {
      if (attempt) finish(attempt, "failed", { error: String(err) });
      throw err;
    }
  };

  window.__estailoATCLoaded = true;
  console.info("ATC tracker loaded:", CONFIG.version);
})();